
import React from "react";
import { TextField, MenuItem, Checkbox, ListItemText, Switch, FormControlLabel } from "@material-ui/core";

/**
 * MultiSelectFilter - Componente reutilizable para filtros de selección múltiple.
 * Muestra directamente el selector de valores (multi-select).
 * Debajo muestra un switch "Excluir valores" que determina el operador:
 * - Switch OFF: no se envía operador (EQUALS si 1 valor, IN si múltiples)
 * - Switch ON: se envía operador NOT_IN
 *
 * Props:
 * - value: array de strings (valores seleccionados — los values técnicos)
 * - onChange: function (callback al cambiar valores, recibe array de values)
 * - options: array de strings O array de { value, label }
 *   - Si son strings, se usan como value y label
 *   - Si son objetos, value es lo que se guarda y label es lo que se muestra
 * - placeholder: string (texto por defecto)
 * - loading: boolean (si está cargando las opciones)
 * - exclude: boolean (si el switch de excluir está activo)
 * - onExcludeChange: function (callback al cambiar el switch)
 */
const MultiSelectFilter = ({ value, onChange, options, placeholder, loading, exclude, onExcludeChange }) => {

    // Normalizar opciones: siempre trabajar con { value, label }
    const normalizedOptions = (options || []).map((opt) => {
        if (typeof opt === "string") return { value: opt, label: opt };
        return { value: opt.value, label: opt.label || opt.value };
    });

    const getLabel = (val) => {
        const found = normalizedOptions.find((o) => o.value === val);
        return found ? found.label : val;
    };

    const handleMultiChange = (event) => {
        onChange(event.target.value);
    };

    return (
        <div>
            {/* Selector de valores (siempre visible, multi-select) */}
            <TextField
                select
                value={value}
                variant="outlined"
                size="small"
                fullWidth
                disabled={loading}
                SelectProps={{
                    multiple: true,
                    renderValue: (selected) => {
                        if (selected.length === 0) return placeholder || "Seleccionar...";
                        if (selected.length === 1) return getLabel(selected[0]);
                        return `${selected.length} seleccionados`;
                    },
                    displayEmpty: true,
                }}
                onChange={handleMultiChange}
                InputProps={{
                    style: { height: "40px", overflow: "hidden" },
                }}
            >
                {loading ? (
                    <MenuItem value="" disabled>Cargando...</MenuItem>
                ) : normalizedOptions.length === 0 ? (
                    <MenuItem value="" disabled>{placeholder || "Sin opciones disponibles"}</MenuItem>
                ) : (
                    normalizedOptions.map((opt, i) => (
                        <MenuItem key={i} value={opt.value}>
                            <Checkbox checked={value.includes(opt.value)} color="primary" size="small" />
                            <ListItemText primary={opt.label} />
                        </MenuItem>
                    ))
                )}
            </TextField>

            {/* Switch Excluir valores */}
            <FormControlLabel
                control={
                    <Switch
                        checked={!!exclude}
                        onChange={(e) => onExcludeChange && onExcludeChange(e.target.checked)}
                        color="primary"
                    />
                }
                label={<span style={{ fontSize: "0.7rem" }}>Excluir valores</span>}
                style={{ marginTop: "4px", marginLeft: 0 }}
                labelPlacement="end"
            />
        </div>
    );
};

export default MultiSelectFilter;
